<script>
import App from '@/pages/layouts/app.vue'
import {Link} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import EmployeeCalendar from "@/pages/appointments/partials/employee-calendar.vue";

export default {
  mixins: [Datatable],
  components: {EmployeeCalendar, Card, App, Link}
}
</script>

<template>
  <App title="Gebruikers">
    <template #topButtons>
      <Link :href="route('users.create')" class="btn btn-primary">
        <i class="bi bi-plus-lg"></i>
        Gebruiker toevoegen
      </Link>
    </template>

    <Card>
      <Table id="users" ref="table" :config="tableConfig"/>
    </Card>
  </App>
</template>